export default HTTPClient => ({
  delete: async (id) => {
    const response = await HTTPClient.delete(`alternatives/${id}`);
    return response;
  },
  create: async (questionID, authorID, alternative) => {
    const response = await HTTPClient.post('alternatives', {
      body: JSON.stringify({
        author_email: authorID,
        question_id: questionID,
        alternative,
      }),
    });
    return response;
  },
  update: async (id, alternative) => {
    const response = await HTTPClient.put(`alternatives/${id}`, {
      body: JSON.stringify(alternative),
    });
    return response;
  },
  attachTopic: async (id, topicID, authorID) => {
    const response = await HTTPClient.post(`alternatives/${id}/topic/attach`, {
      body: JSON.stringify({
        topic_id: topicID,
        author_id: authorID,
      }),
    });
    return response;
  },
  detachTopic: async (id, topicID, authorID) => {
    const response = await HTTPClient.post(`alternatives/${id}/topic/detach`, {
      body: JSON.stringify({
        topic_id: topicID,
        author_id: authorID,
      }),
    });
    return response;
  },
});
